// extracted by mini-css-extract-plugin
export default {"products":"HA-z","card":"IA-z","oosMessaging":"JA-z"};